import styled from 'styled-components';

type StarProps = {
  color: string;
};

const SvgContainer = styled.svg`
  width: 0.75rem;
  height: 0.75rem;
  margin-right: 0.25rem;
  fill: none;
  @media ${({ theme }): string => theme.devices.laptop} {
    width: 1.125rem;
    height: 1.0625rem;
    margin-right: 0.375rem;
  }
`;

const Star = ({ color }: StarProps): JSX.Element => (
  <SvgContainer
    width="18"
    viewBox="0 0 18 17"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.10682 0.627296C8.40119 -0.209098 9.59881 -0.209099 9.89318 0.627295L11.4518 5.05605C11.5817 5.42502 11.9303 5.67519 12.3257 5.68315L17.072 5.77868C17.9683 5.79672 18.3384 6.92169 17.624 7.45665L13.8411 10.2893C13.5259 10.5253 13.3927 10.9301 13.5073 11.304L14.8819 15.7918C15.1416 16.6393 14.1727 17.3346 13.4368 16.8288L9.54011 14.1507C9.21547 13.9276 8.78453 13.9276 8.45989 14.1507L4.56325 16.8288C3.82735 17.3346 2.85844 16.6393 3.11806 15.7918L4.49274 11.304C4.60727 10.9301 4.47411 10.5253 4.15894 10.2893L0.375999 7.45665C-0.33843 6.92169 0.031657 5.79672 0.92801 5.77868L5.67426 5.68315C6.06968 5.67519 6.41831 5.42502 6.54817 5.05605L8.10682 0.627296Z"
      fill={color === 'rated' ? 'var(--beek-blue)' : 'var(--gray-15)'}
    />
  </SvgContainer>
);

export default Star;
